// a safe function to compare two numbers. input can be number, NaN, undefined, null, or Infinity.
export function compareNumber(value1?: number | null, value2?: number | null): number {
  if (value1 === value2 || (value1 == null && value2 == null)) {
    return 0;
  }
  if (value1 == null || Number.isNaN(value1) || value1 === Number.POSITIVE_INFINITY) {
    return 1;
  }
  if (value2 == null || Number.isNaN(value2) || value2 === Number.POSITIVE_INFINITY) {
    return -1;
  }
  if (value1 < value2) {
    return -1;
  }
  if (value1 > value2) {
    return 1;
  }
  throw new Error('Unexpected case');
}
